import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import {
    log,
    jsonParse,
} from '@/js/function';

Vue.use(Vuex);

const state = {
    user: (window.localStorage.getItem('user')) ? jsonParse(window.localStorage.getItem('user')) : {
        email: 'guess',
    },
    selectProject: (window.localStorage.getItem('selectProject')) ? jsonParse(window.localStorage.getItem('selectProject')) : {
        projectId: null,
        projectName: null,
        record: [],
        images: [],
    },
    loading: false,
    progress: 100,
    progressArray: [],
};
const myPlugin = (store) => { // Plugins https://vuex.vuejs.org/en/plugins.html
    store.subscribe((mutation, state) => {});
};
const store = new Vuex.Store({
    plugins: [myPlugin],
    state,
    getters,
    actions,
    mutations,
    strict: process.env.NODE_ENV !== 'production',
});
if (module.hot) {
    module.hot.accept([
        './getters',
        './actions',
        './mutations',
    ], () => {
        store.hotUpdate({
            getters: require('./getters'),
            actions: require('./actions'),
            mutations: require('./mutations'),
        });
    });
}
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js